var _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWeatherWind(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_43_2895)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64.1165 35.2557C63.2865 23.1079 53.1792 13.5107 40.8239 13.5107C28.4687 13.5107 18.3614 23.1079 17.5313 35.2557C8.32325 35.7053 1 43.3138 1 52.6257C1 61.9375 8.79014 70.0216 18.396 70.0216H63.2346C72.8404 70.0216 80.6306 62.2315 80.6306 52.6257C80.6306 43.0199 73.3073 35.7053 64.1079 35.247L64.1165 35.2557Z",
    fill: "url(#paint0_radial_43_2895)"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M40.8238 37.4174C34.2701 32.1 31.7195 24.0159 35.1087 19.347C38.5067 14.6782 46.5735 15.2056 53.1272 20.5143C59.6723 25.8316 62.2315 33.9244 58.8336 38.5846C55.4357 43.2535 47.3689 42.7261 40.8238 37.4174Z",
    fill: "url(#paint1_radial_43_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M64.2374 53.1274C59.093 48.9513 57.0784 42.5878 59.7501 38.9219C62.4217 35.2559 68.7593 35.6623 73.9037 39.8384C79.0482 44.0144 81.0541 50.3779 78.3911 54.0439C75.7194 57.7185 69.3818 57.3035 64.2374 53.1274Z",
    fill: "url(#paint2_radial_43_2895)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.2,
    d: "M13.4414 53.7071C9.64577 47.7845 5.22761 44.9313 3.57621 47.3349C1.93345 49.7385 3.67131 56.4911 7.46695 62.4223C11.2712 68.3449 15.6807 71.1981 17.3321 68.7945C18.9836 66.3822 17.237 59.6383 13.4414 53.7071Z",
    fill: "url(#paint3_radial_43_2895)"
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M69.8659 49.5567H45.1554C43.0025 49.5567 41.2646 47.8189 41.2646 45.666C41.2646 43.5131 43.0025 41.7752 45.1554 41.7752H69.8659C72.8402 41.7752 75.2525 39.363 75.2525 36.3887C75.2525 33.4145 72.8402 31.0022 69.8659 31.0022C67.7131 31.0022 65.9752 29.2643 65.9752 27.1114C65.9752 24.9586 67.7131 23.2207 69.8659 23.2207C77.1287 23.2207 83.034 29.126 83.034 36.3887C83.034 43.6514 77.1287 49.5567 69.8659 49.5567Z",
    fill: "url(#paint4_radial_43_2895)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5871 53.6636H56.162C54.3031 53.6636 52.79 55.1766 52.79 57.0356C52.79 58.8945 54.3031 60.4075 56.162 60.4075H77.5871C80.1636 60.4075 82.2559 62.4999 82.2559 65.0764C82.2559 67.653 80.1636 69.7453 77.5871 69.7453C75.7281 69.7453 74.2151 71.2584 74.2151 73.1173C74.2151 74.9762 75.7281 76.4893 77.5871 76.4893C83.8814 76.4893 89.0085 71.3708 89.0085 65.0764C89.0085 58.7821 83.8901 53.6636 77.5871 53.6636Z",
    fill: "url(#paint5_radial_43_2895)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_43_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(50.8621 25.4256) rotate(-180) scale(60.7475 44.3457)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#85BCF1"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_43_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(202.847 -189.577) rotate(126.03) scale(10.4846 15.2503)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_43_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(225.789 -173.272) rotate(126.03) scale(8.23437 11.9773)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_43_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(10.441 58.0263) rotate(-25.71) scale(4.21065 12.253)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.29,
    stopColor: "white",
    stopOpacity: 0.59
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.47,
    stopColor: "white",
    stopOpacity: 0.38
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.63,
    stopColor: "white",
    stopOpacity: 0.22
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.78,
    stopColor: "white",
    stopOpacity: 0.1
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.91,
    stopColor: "white",
    stopOpacity: 0.03
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_43_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(62.145 36.3887) scale(17.4565 17.4565)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FD"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_43_2895",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(70.895 65.0764) scale(15.1393)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6,
    stopColor: "#D5F3FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EAF4FD"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_43_2895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 88,
    height: 62.9782,
    fill: "white",
    transform: "translate(1 13.5107)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWeatherWind);
export default __webpack_public_path__ + "static/media/weather-wind.6adce1e0eea68522ddc42cd525acc975.svg";
export { ForwardRef as ReactComponent };